import enrolLoyaltyAccount from 'actions/loyalty/enrolLoyaltyAccount'
import ModalContext from 'contexts/ModalContext'
import { useAppDispatch } from 'hooks/reduxHooks'
import TextButton from 'LuxKit/Button/TextButton'
import LoyaltyJoinModal from 'loyalty/components/LoyaltyJoinModal'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'

function LoyaltyPurchasePointsNeedsMembershipCta() {
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const showModal = useContext(ModalContext)

  const buttonText = intl.formatMessage({
    id: 'T9UHtgcdpQXkdUjc8gMK',
    defaultMessage: 'Activate membership',
    description: 'Primary button text on the loyalty join modal when a user clicks Join Société from the Maldives charter calendar.',
  })

  const onActivateClick = useCallback(async() => {
    const joinConfirmed = await showModal<boolean>(<LoyaltyJoinModal
      onAfterClose={() => {}}
      primaryActionCta={buttonText}
    />)
    if (joinConfirmed) {
      dispatch(enrolLoyaltyAccount({ enrolment: 'existingUserRegistration' }))
    }
  }, [showModal, buttonText, dispatch])

  return <TextButton kind="primary" size="large" onClick={onActivateClick}>
    {buttonText}
  </TextButton>
}

export default LoyaltyPurchasePointsNeedsMembershipCta
